import React, { useState } from 'react';
import { Box } from '@mui/material';
import CustomAppBar from '../Common/Layout/CustomAppBar';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import HistoryIcon from '@mui/icons-material/History';
import TabPanel from '../Common/Layout/TabPanel';
import IndexList from './IndexList';
import IndexSerieList from './IndexSerieList';

const IndexInfoWrapper: React.FunctionComponent = () => {
  const [value, setValue] = useState(0);

  return (
    <Box style={{ width: '100%' }}>
      <Box>
        <CustomAppBar
          value={value}
          handleChange={(_, newValue) => setValue(newValue)}
          type="first"
          tabProps={[
            {
              id: 'membership-details',
              title: 'Indexes',
              icon: FormatListBulletedIcon
            },
            {
              id: 'membership-companies',
              title: 'Index series',
              icon: ImportContactsIcon
            },
            {
              id: 'membership-contacts',
              title: 'Data history',
              icon: HistoryIcon
            }
          ]}
        />
        <Box>
          <TabPanel value={value} index={0}>
            <IndexList />
          </TabPanel>
        </Box>
        <TabPanel value={value} index={1}>
          <IndexSerieList />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default IndexInfoWrapper;
